import React from "react"
import style from "./RadioButton.module.scss"
import cn from "classnames"
import { MileId } from "../data/enums"

interface Props {
  title: string
  name: string
  value: MileId
  checked: boolean

  onChange: (value: MileId) => void
}

export const RadioButtonComponent: React.FC<Props> = (props) => {
  const { title, name, value, checked, onChange } = props
  return (
    <label className={cn(style.control, style.control_radio)}>
      <span>{title}</span>
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={() => onChange(value)}
      />
      <div className={style.control_indicator}></div>
    </label>
  )
}
